import React, { Component } from "react";
import CartContext from "./CartContext";
import { BsFillPencilFill } from "react-icons/bs";
import { BiRefresh } from "react-icons/bi";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Swal from "sweetalert2";
import { ViewCustomerOrders } from "./Customers";

import {
  Modal,
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export default class PosUsers extends Component {
  static contextType = CartContext;
  state = {
    users: [],
    loadSpinnerOpen: true,
    msgboxOpen: false,
    msgboxTitle: "",
    msgboxMessage: "",
    reload: true,
  };

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });
  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  OnDeleted = (indexno) => {
    const list = [...this.state.users];
    list.splice(indexno, 1);
    this.setState({ users: list });
  };

  OnUpdated = () => this.OnRefreshButtonClick();
  addModalClose = () => this.setState({ addModalShow: false });
  OnRefreshButtonClick = () => this.GetPosUsers();

  GetPosUsers = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetPosUsers/" +
        this.context.storeId,
      {
        headers: {
          Authorization: `Bearer ${this.context.userData.bearertoken}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (!data?.status) this.setState({ users: data });
      })
      .catch(() => {
        this.ShowMessagBox("Warning", "Session Timeout!");
        this.context.clearUserData();
      });
  };

  componentDidMount() {
    this.GetPosUsers();
    setTimeout(() => this.setState({ loadSpinnerOpen: false }), 500);
  }

  render() {
    return (
      <>
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

        <Navbar className="shadow position-sticky fixed-top py-2 bg-white">
          <h3>Billing POS Users</h3>
          <Navbar.Collapse className="justify-content-end mx-1">
            <Nav>
              <ButtonToolbar>
                <Button
                  className="mainthemecolor"
                  disabled={
                    this.state.users.length >=
                    (this.context.storeSettings.totalPosUsers || 0)
                  }
                  onClick={() => {
                    if (
                      this.state.users.length >=
                      (this.context.storeSettings.totalPosUsers || 0)
                    ) {
                      Swal.fire("Info", "POS User limit reached!", "info");
                      return;
                    }
                    this.setState({ addModalShow: true });
                  }}
                >
                  + Add
                </Button>
                &nbsp;
                <Button
                  className="mainthemecolor"
                  onClick={this.OnRefreshButtonClick}
                >
                  <BiRefresh size={22} /> Refresh
                </Button>
                {this.state.addModalShow && (
                  <AddOrEditPosUserModal
                    show={this.state.addModalShow}
                    Type="Add"
                    onHide={this.addModalClose}
                  />
                )}
              </ButtonToolbar>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <div className="p-2" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <Table striped bordered hover className="bg-white">
            <thead
              className="table-light"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              <tr className="text-start" style={{ fontSize: "12px" }}>
                <th>#</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Role</th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              {this.state.users.map((user, i) => (
                <EditUserInline
                  key={user.id}
                  index={i}
                  user={user}
                  OnDeleted={this.OnDeleted}
                  OnUpdated={this.OnUpdated}
                />
              ))}
            </tbody>
          </Table>
        </div>
      </>
    );
  }
}

class EditUserInline extends Component {
  static contextType = CartContext;
  state = { editModalShow: false, showOrdersModal: false };

  OnDelete = () => {
    Swal.fire({
      title: "Delete POS User?",
      text: "This will permanently delete the user",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    }).then((r) => {
      if (!r.isConfirmed) return;
      fetch(
        process.env.REACT_APP_API +
          "StoreManager/DeletePosUser/" +
          this.props.user.id,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${this.context.userData.bearertoken}`,
          },
        }
      ).then((res) => {
        if (res.status === 200) {
          this.props.OnDeleted(this.props.index);
          Swal.fire("Deleted!", "POS User removed successfully", "success");
        } else Swal.fire("Error", "Delete failed!", "error");
      });
    });
  };

  render() {
    const u = this.props.user;
    const roleName =
      this.context.posRoles.find((f) => f.id === u.posRoleId)?.roleName || "";
    return (
      <>
        {this.state.showOrdersModal && (
          <ViewCustomerOrders
            customer={u}
            Close={() => this.setState({ showOrdersModal: false })}
          />
        )}
        {this.state.editModalShow && (
          <AddOrEditPosUserModal
            show={this.state.editModalShow}
            onHide={() => {
              this.setState({ editModalShow: false });
              this.props.OnUpdated();
            }}
            user={u}
            Type="Edit"
          />
        )}
        <tr className="text-start align-middle" style={{ fontSize: "12px" }}>
          <td>{this.props.index + 1}</td>
          <td>{u.firstName}</td>
          <td>{u.emailId}</td>
          <td>{u.mobileNo}</td>
          <td>{roleName}</td>
          <td>
            <Button
              size="sm"
              className="mainthemecolor me-2"
              onClick={() => this.setState({ showOrdersModal: true })}
            >
              Orders
            </Button>
            <Button
              size="sm"
              variant="warning"
              onClick={() => this.setState({ editModalShow: true })}
            >
              <BsFillPencilFill />
            </Button>
            &nbsp;
            <Button size="sm" variant="danger" onClick={this.OnDelete}>
              🗑
            </Button>
          </td>
        </tr>
      </>
    );
  }
}

class AddOrEditPosUserModal extends Component {
  static contextType = CartContext;
  state = {
    user: {
      firstName: "",
      emailId: "",
      mobileNo: "",
      posRoleId: "",
      customerUserTypeId: 3,
    },
  };

  componentDidMount() {
    if (this.props.Type === "Edit") this.setState({ user: this.props.user });
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({ user: { ...prev.user, [name]: value } }));
  };

  validateUser = () => {
    const u = this.state.user;
    if (!u.firstName || !u.emailId || !u.mobileNo) {
      Swal.fire("Error", "All fields are required", "error");
      return false;
    }
    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(u.emailId)) {
      Swal.fire("Error", "Invalid email format", "error");
      return false;
    }
    if (!/^\d{10}$/.test(u.mobileNo)) {
      Swal.fire("Error", "Mobile number must be 10 digits", "error");
      return false;
    }
    return true;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.validateUser()) return;

    const payload = { ...this.state.user, storeId: this.context.storeId };
    fetch(process.env.REACT_APP_API + "StoreManager/AddPosUser/", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.context.userData.bearertoken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }).then((res) => {
      if (res.status === 200) {
        Swal.fire("Saved!", "POS User saved successfully", "success").then(() =>
          this.props.onHide()
        );
      } else if (res.status === 409) {
        Swal.fire("Warning", "User already exists", "warning");
      } else {
        Swal.fire("Error", "Save failed!", "error");
      }
    });
  };

  render() {
    const u = this.state.user;
    return (
      <Modal {...this.props} centered backdrop="static">
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header closeButton className="bg-warning">
            <Modal.Title>
              {this.props.Type === "Edit" ? "Edit POS User" : "Add POS User"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm="4">
                User Name
              </Form.Label>
              <Col sm="8">
                <Form.Control
                  name="firstName"
                  value={u.firstName}
                  onChange={this.handleInputChange}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm="4">
                Email
              </Form.Label>
              <Col sm="8">
                <Form.Control
                  name="emailId"
                  value={u.emailId}
                  onChange={this.handleInputChange}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm="4">
                Phone
              </Form.Label>
              <Col sm="8">
                <Form.Control
                  name="mobileNo"
                  value={u.mobileNo}
                  onChange={this.handleInputChange}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-2">
              <Form.Label column sm="4">
                Role
              </Form.Label>
              <Col sm="8">
                <Form.Select
                  name="posRoleId"
                  value={u.posRoleId}
                  onChange={this.handleInputChange}
                  required
                >
                  <option value=""></option>
                  {this.context.posRoles.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.roleName}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Save
            </Button>
            <Button variant="secondary" onClick={this.props.onHide}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}
